<template>
  <o-menu :router="true">
    <o-menu-list>
      <o-menu-item label="Dashboard"   tag="router-link" :to="{ path: '/dashboard' }" >
      </o-menu-item>
<!--      <emails-menu/>-->
<!--      <slack-menu/>-->
      <o-menu-item v-if="checkPermissions('emails.index')" label="Emails"   tag="router-link" :to="{ name: 'emails' }">
        <emails-menu/>
      </o-menu-item>
      <o-menu-item v-if="checkPermissions('slack.index')" label="Slack"   tag="router-link" :to="{ name: 'slack' }">
        <slack-menu/>
      </o-menu-item>
      <o-menu-item v-if="checkPermissions('companies.index')" label="Companies"   tag="router-link" :to="{ name: 'companies.index' }">
      </o-menu-item>
      <o-menu-item v-if="checkPermissions('projects.index')" label="Projects"   tag="router-link" :to="{ name: 'projects.index' }">
      </o-menu-item>
      <o-menu-item v-if="checkPermissions('tasks.index')" label="Tasks"   tag="router-link" :to="{ name: 'tasks.index' }">
      </o-menu-item>
      <o-menu-item v-if="checkPermissions('proposals.index')" label="Proposals"   tag="router-link" :to="{ name: 'proposals.index' }">
      </o-menu-item>
      <!-- Reports -->
      <o-menu-item label="Reports" tag="router-link" :to="{ name: 'reports.list' }">
      </o-menu-item>
      <o-menu-item class="marg">
        <template #label="props">
          <router-link v-if="checkPermissions('reminders.index')" @click="closeSidebar" :to="{ name: 'reminders.index' }">
            Reminders
            <span v-if="counts.reminders" class="tag is-rounded is-black color-pink is-pulled-right" id="reminders">
                        {{ countReminders }}
                    </span>
          </router-link>
        </template>
      </o-menu-item>
      <o-menu-item v-if="checkPermissions('time-logs.index')"  label="Time Manager"   tag="router-link" :to="{ name: 'time-logs.index' }">
      </o-menu-item>
      <b-menu-dropdown>
        <template v-slot:trigger>
          <o-menu-item label="Settings">
            <o-menu-item v-if="currentUserIsAdmin" label="General"   tag="router-link" :to="{ name: 'settings.general' }">
            </o-menu-item>
            <o-menu-item v-if="currentUserIsAdmin" label="Teams"   tag="router-link" :to="{ name: 'teams.index' }">
            </o-menu-item>
            <o-menu-item v-if="currentUserIsAdmin" label="Users"   tag="router-link" :to="{ name: 'users.index' }">
            </o-menu-item>
            <o-menu-item v-if="currentUserIsEmployee" label="Personal Dashboard"   tag="router-link" :to="{ name: 'users.index' }">
            </o-menu-item>
            <o-menu-item label="Services"   tag="router-link" :to="{ name: 'services.index' }">
            </o-menu-item>
            <o-menu-item label="Roles"   tag="router-link" :to="{ name: 'roles.index' }">
            </o-menu-item>
            <b-menu-dropdown>
              <template v-slot:trigger>
                <o-menu-item label="Permit Types">
                  <o-menu-item label="Dob"   tag="router-link" :to="{ name: 'dob-permit-types.index' }">
                  </o-menu-item>
                  <o-menu-item label="Dot"   tag="router-link" :to="{ name: 'dot-permit-types.index' }">
                  </o-menu-item>
                </o-menu-item>
              </template>

            </b-menu-dropdown>
            <b-menu-dropdown>
              <template v-slot:trigger>
                <o-menu-item label="Work Types">
                  <o-menu-item label="Service"   tag="router-link" :to="{ name: 'service-work-types.index' }">
                  </o-menu-item>
                  <o-menu-item label="Job"   tag="router-link" :to="{ name: 'job-work-types.index' }">
                  </o-menu-item>
                </o-menu-item>
              </template>
            </b-menu-dropdown>
            <o-menu-item label="Audit Log"   tag="router-link" :to="{ name: 'audit-logs.index' }">
            </o-menu-item>
            <o-menu-item label="Universal Documents"   tag="router-link" :to="{ name: 'universal-documents.index' }">
            </o-menu-item>
            <o-menu-item label="Notification Settings"   tag="router-link" :to="{ name: 'notification-settings' }">
            </o-menu-item>
          </o-menu-item>
        </template>
        </b-menu-dropdown>
    </o-menu-list>
  </o-menu>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { EmailsMenu } from '../modules/emails';
import SlackMenu from '../modules/slack/components/sidemenu/SlackMenu';
import { checkPermissions } from "../utils";

export default {
  components: {
    EmailsMenu,
    SlackMenu,
  },

  data() {
    return {
      counts: {},
      fetchingNotifications: false,
    }
  },

  computed: {
    ...mapGetters(['currentUserIsAdmin', 'currentUserId', 'emails_label', 'currentUserIsEmployee', "reminders"]),

    countReminders() {
      return this.reminders.length
    },
  },

  mounted() {
    this.fetchCounts()

    echo.private('App.Models.User.' + this.currentUserId)
        .listen('ReminderCreated', (e) => {
          this.counts.reminders = e.remindersCount
          this.fetchNotifications()
        })
        .listen('NotificationUpdated', () => {
          this.fetchNotifications()
        })

    echo.channel('public')
        .listen('ProposalCreated', (e) => {
          this.counts.proposals = e.proposalsCount
        }).listen('ProjectCreated', (e) => {
      this.counts.projects = e.projectsCount
    })
  },

  beforeUnmount() {
    clearInterval(this.countsInterval)
  },

  methods: {
    ...mapActions(['closeSidebar', 'emails_set_label', 'fetchUnreadLatest5Notifications']),
    fetchCounts() {
      axios.get(`/api/dictionaries/counts`)
          .then(res => {
            this.counts = res.data.data
            return res
          })
    },
    fetchNotifications() {
      if (!this.fetchingNotifications) {
        this.fetchingNotifications = true
        _.delay(() =>
                this.fetchUnreadLatest5Notifications()
                    .then(() => this.fetchingNotifications = false)
            , 500)
      }
    },

    checkPermissions(rule) {
      if (Laravel.currentUser && Laravel.currentUser.role !== "admin") {
        if (!checkPermissions(rule, Laravel.currentUser.permissions)) {
          return false;
        }
      }

      return true
    }
  }
}
</script>

<style>
.sidebar-page {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100%;
}
.sidebar-layout {
  display: flex;
  flex-direction: row;
  min-height: 100%;
}
</style>
